import { lazy, Suspense, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { ORGANIZATION_SCHEMA } from "./components/Seo";
import { Home } from "./pages/Home";

// Home is not lazy: it's the landing page most visits hit first, so deferring
// it behind an extra chunk request would delay its own LCP for no benefit —
// there's no other page to save bytes for on a first visit to "/".
const Sobre = lazy(() => import("./pages/Sobre").then((m) => ({ default: m.Sobre })));
const Servicos = lazy(() => import("./pages/Servicos").then((m) => ({ default: m.Servicos })));
const BlogList = lazy(() => import("./pages/BlogList").then((m) => ({ default: m.BlogList })));
const BlogPost = lazy(() => import("./pages/BlogPost").then((m) => ({ default: m.BlogPost })));
const NotFound = lazy(() => import("./pages/NotFound").then((m) => ({ default: m.NotFound })));

export default function App() {
  // The static tags in index.html (marked data-default) exist as a fallback for
  // crawlers that don't run JS (WhatsApp, Facebook link previews). Once React mounts
  // and each route's <Seo> injects its own tags via Helmet, the static ones become
  // stale duplicates (e.g. two conflicting <link rel="canonical">) — strip them once.
  useEffect(() => {
    document.querySelectorAll("[data-default]").forEach((el) => el.remove());
  }, []);

  return (
    <Router>
      <div className="bg-brand-dark min-h-screen text-brand-light selection:bg-brand-accent selection:text-brand-light relative">
        {/* Global Textures */}
        <div className="pointer-events-none fixed inset-0 z-50 bg-noise opacity-[0.04] mix-blend-overlay"></div>
        <div className="pointer-events-none fixed inset-0 z-50 bg-paper opacity-[0.03] mix-blend-overlay"></div>

        <Helmet>
          <script type="application/ld+json">{JSON.stringify(ORGANIZATION_SCHEMA)}</script>
        </Helmet>

        <Navbar />
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sobre" element={<Sobre />} />
            <Route path="/servicos" element={<Servicos />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <Footer />
        <ScrollToTop />
        <WhatsAppButton />
      </div>
    </Router>
  );
}
